// Called by : src/App.vue (button-goback)

<template>
    <button class="btn btn-outline-light px-4 py-2 txt_ombre_333 txt_size_125" @click="goBack">
        <span class="oi oi-chevron-left mr-2" style="font-size: 1rem;"></span>
        {{ $t('question.goBack') }}
    </button>
</template>

<script>
export default {
  methods: {
    goBack() {

      // bascule vers "Patience.vue"
      var oParams = {
        sTitlePage: null, // this.lesson.name,
        sTextHeader: null,
        sTextFooter: null,
        nTimeout: this.params.patienceTime / 4,
        sRouteName: null,
      };
      this.$router.push({ name: 'patience', params: oParams });
      // this.$router.go(-1);
      // this.$router.push({ name: 'assignments' });
    },
  },
  computed: {
    params() {
      return this.$store.state.params
    },  
  },
}
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/header/ButtonGoBack.vue